import styled from "@emotion/styled";
import { Container, Typography, Button, Box } from "@mui/material";

export const RootBox = styled(Box)(({ theme }: any) => ({
  background: "#fff",
  borderRadius: "0.5rem",
  width: theme.breakpoints.down("md") ? "100%" : "384px",
}));

export const LoginTitle = styled(Typography)(({ theme }) => ({
  fontSize: 28,
  fontWeight: 500,
  // fontFamily: ['Inter', 'sans-serif'].join(','),
  color: "#565656",
  marginBottom: "1.5rem",
  textAlign: "left",
}));

export const SocialPill = styled(Button)(({ theme }: any) => ({
  background: "#FFF",
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: "10rem",
  padding: "0.6rem 1rem",
  margin: "0.5rem",
}));
